// src/routes/ReportRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Report Components
import SalesReportPage from '../pages/reports/SalesReportPage';
import CourierPerformancePage from '../pages/reports/CourierPerformancePage';
import PnlReportPage from '../pages/reports/PnlReportPage';
import ProductWiseSalesPage from '../pages/reports/ProductWiseSalesPage';
import ProductWiseReturnsPage from '../pages/reports/ProductWiseReturnsPage';
import MessageCenterSummaryPage from '../pages/reports/MessageCenterSummaryPage';
import CallCenterSummaryPage from '../pages/reports/CallCenterSummaryPage';
import CallcenterPerformancePage from '../pages/reports/CallcenterPerformancePage';

const ReportRoutes = () => {
  return (
    <Routes>
      {/* Sales Report */}
      <Route 
        path="/sales" 
        element={
          <PermissionRoute requiredPermission="view_sales_reports">
            <SalesReportPage />
          </PermissionRoute>
        } 
      />

      {/* Product Wise Sales Report */}
      <Route
        path="/product-wise-sales"
        element={
          <PermissionRoute requiredPermission="view_sales_reports">
            <ProductWiseSalesPage />
          </PermissionRoute>
        }
      />

      {/* Product Wise Returns Report */}
      <Route
        path="/product-wise-returns"
        element={
          <PermissionRoute requiredPermission="view_sales_reports">
            <ProductWiseReturnsPage />
          </PermissionRoute>
        }
      />

      {/* Profit & Loss Report */}
      <Route
        path="/pnl"
        element={
          <PermissionRoute requiredPermission="view_sales_reports">
            <PnlReportPage />
          </PermissionRoute>
        }
      />

      {/* Courier Performance Report */}
      <Route
        path="/courier-performance"
        element={
          <PermissionRoute requiredPermission="view_courier_performance_report">
            <CourierPerformancePage />
          </PermissionRoute>
        }
      />

      {/* Message Center Summary Report */}
      <Route
        path="/message-center-summary"
        element={
          <PermissionRoute requiredPermission="view_message_center_summary_report">
            <MessageCenterSummaryPage />
          </PermissionRoute>
        }
      />

      {/* Call Center Summary Report */}
      <Route
        path="/callcenter-summary"
        element={
          <PermissionRoute requiredPermission="view_callcenter_summary_report">
            <CallCenterSummaryPage />
          </PermissionRoute>
        }
      />

      {/* Call Center Performance Report */}
      <Route
        path="/callcenter-performance"
        element={
          <PermissionRoute requiredPermission="view_callcenter_performance_report">
            <CallcenterPerformancePage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default ReportRoutes;